import * as React from "react";
import { useDispatch } from "@teamprevent/admin-redux";
import { Confirm } from "semantic-ui-react";

import { TaskModel } from "@teamprevent/common/task/taskActions/models";
import { IsLoadingButton } from "@teamprevent/common/IsLoadingButton";

import { COMPLETE_NOW_HEALTH_SURVEILLANCE_QUESTIONNAIRE } from "../../healthSurveillance/actionTypes";
import { completeNowHealthSurveillanceQuestionnaire } from "../../healthSurveillance/actions";

interface Props {
    task: TaskModel;
}

export const CompleteNowHealthSurveillanceQuestionnaireButton: React.FunctionComponent<Props> = (props: Props) => {
    const dispatch = useDispatch();

    const [modalOpen, setModalOpen] = React.useState<boolean>(false);

    const onCompleteNow = React.useCallback(() => setModalOpen(true), [props.task]);

    const onCancel = React.useCallback(() => setModalOpen(false), [props.task]);

    const completeNow = React.useCallback(
        () => {
            dispatch(completeNowHealthSurveillanceQuestionnaire(props.task.customer.id, props.task.caseId, props.task.id));
            setModalOpen(false);
        },
        [props.task]
    );

    return (
        <>
            <Confirm
                open={modalOpen}
                // eslint-disable-next-line max-len
                content="This will prevent you from booking an appointment for the HS/FFW consultation and allow you to complete a consultation that has taken place already. Are you sure you with to continue?"
                onCancel={onCancel}
                onConfirm={completeNow}
            />
            <IsLoadingButton
                content="Complete Now"
                onClick={onCompleteNow}
                requestNames={COMPLETE_NOW_HEALTH_SURVEILLANCE_QUESTIONNAIRE}
                floated="right"
            />
        </>
    );
};
